// extracted by mini-css-extract-plugin
export default {"backLink":"BackButton_backLink__HY0Fv","text":"BackButton_text__t3NC0","rotateArrow":"BackButton_rotateArrow__UXHqn"};